module.exports = __webpack_public_path__ + "static/img/rice-paper.df214853.jpg";